export const VALID_KEN_BURNS_EFFECTS = Object.freeze([
  "none",
  "spotlight",
  "pulse",
  "blur",
  "lens",
]);

export const clampKenBurnsFocus = (focus) => {
  const x = Math.max(-1.0, Math.min(1.0, focus?.x ?? 0));
  const y = Math.max(-1.0, Math.min(1.0, focus?.y ?? 0));
  const zoom = Math.max(1.0, Math.min(2.5, focus?.zoom ?? 1.0));
  const effect = focus?.effect;
  if (effect && VALID_KEN_BURNS_EFFECTS.includes(effect) && effect !== "none") {
    return { x, y, zoom, effect };
  }
  return { x, y, zoom };
};

export const computeKenBurnsStyle = (focus, prefersReducedMotion = false) => {
  const clamped = clampKenBurnsFocus(focus);
  const xOffset = clamped.x * 50;
  const yOffset = clamped.y * 50;
  const transformOrigin = `calc(50% + ${xOffset}%) calc(50% - ${yOffset}%)`;

  if (prefersReducedMotion) {
    return {
      transform: "scale(1)",
      transformOrigin,
      willChange: "transform",
      transition: "none",
    };
  }

  return {
    transform: `scale(${clamped.zoom})`,
    transformOrigin,
    willChange: "transform",
    transition:
      "transform 1.2s cubic-bezier(0.25, 0.1, 0.25, 1), transform-origin 1.2s cubic-bezier(0.25, 0.1, 0.25, 1)",
  };
};

export const createCoverDragOrigin = ({
  rect,
  natW = 0,
  natH = 0,
  currentFocus = { x: 0, y: 0 },
  currentZoom = 1.0,
  fallbackWidth = 1,
  fallbackHeight = 1,
}) => {
  const hasLayout = rect && rect.width > 0 && rect.height > 0;
  const u0 = (currentFocus.x + 1) / 2;
  const v0 = (1 - currentFocus.y) / 2;

  if (hasLayout && natW > 0 && natH > 0) {
    const scaleCover = Math.max(rect.width / natW, rect.height / natH);
    return {
      u0,
      v0,
      focalScreenX: rect.left + u0 * rect.width,
      focalScreenY: rect.top + v0 * rect.height,
      renderW: natW * scaleCover * currentZoom,
      renderH: natH * scaleCover * currentZoom,
      isCover: true,
    };
  }

  return {
    bLeft: hasLayout ? rect.left : 0,
    bTop: hasLayout ? rect.top : 0,
    bWidth: hasLayout ? rect.width : fallbackWidth,
    bHeight: hasLayout ? rect.height : fallbackHeight,
    isCover: false,
  };
};

export const computeCoverFocusPoint = (clientX, clientY, origin) => {
  if (!origin) return { rawX: 0, rawY: 0 };
  let uClicked;
  let vClicked;

  if (origin.isCover) {
    uClicked = Math.max(0, Math.min(1, origin.u0 + (clientX - origin.focalScreenX) / origin.renderW));
    vClicked = Math.max(0, Math.min(1, origin.v0 + (clientY - origin.focalScreenY) / origin.renderH));
  } else {
    uClicked = Math.max(0, Math.min(1, (clientX - origin.bLeft) / origin.bWidth));
    vClicked = Math.max(0, Math.min(1, (clientY - origin.bTop) / origin.bHeight));
  }

  return {
    rawX: uClicked * 2 - 1,
    rawY: 1 - vClicked * 2,
  };
};
